const Image = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
    >
      <path
        d="M1.09195 16H17.908C18.5086 16 19 15.5068 19 14.9041V1.09589C19 0.493151 18.5086 0 17.908 0H1.09195C0.491379 0 0 0.493151 0 1.09589V14.9041C0 15.5068 0.491379 16 1.09195 16ZM14.9685 2.16767C16.0102 2.16767 16.8554 3.01589 16.8554 4.06137C16.8554 5.10685 16.0102 5.95507 14.9685 5.95507C13.9268 5.95507 13.0816 5.10685 13.0816 4.06137C13.0816 3.01589 13.9268 2.16767 14.9685 2.16767ZM2.02885 12.9205L6.87494 6.19178C7.22655 5.70301 7.8031 5.70301 8.15471 6.19178L11.02 10.1677C11.3716 10.6564 11.9482 10.6564 12.2998 10.1677L13.0794 9.08493C13.431 8.59616 14.0076 8.59616 14.3592 9.08493L17.1218 12.9205C17.4734 13.4093 17.2703 13.8082 16.6698 13.8082H2.48092C1.88034 13.8082 1.67724 13.4093 2.02885 12.9205Z"
        fill="#D1D1D1"
      />
    </svg>
  );
};

export default Image;
